
export class FalhaServico{
    bloco: string;
    code: string;
    message: string;

    constructor(){
        this.bloco = '';
        this.code = '';
        this.message = '';
    }
} 

